// src/components/SubjectCountView.js
import React, { useEffect, useState } from "react";
import "./subject.css";
import api from "../../../api/api";

const SubjectCountView = () => {
  const [subjectCount, setSubjectCount] = useState(null);
  const token = localStorage.getItem("access");

  useEffect(() => {
    const fetchSubjectCount = async () => {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await api.get("subjects/count/", config);
        setSubjectCount(response.data.total_subject_count);
      } catch (err) {
        console.error("Error fetching subject count:", err);
      }
    };

    fetchSubjectCount();
  }, [token]);

  return (
    <div className="totalsubject">
      <p>Total Subjects: {subjectCount}</p>
    </div>
  );
};

export default SubjectCountView;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./subject.css";

// const SubjectCountView = () => {
//   const [subjectCount, setSubjectCount] = useState(null);

//   const token = localStorage.getItem("access");
//   useEffect(() => {
//     const fetchSubjectCount = async () => {
//       try {
//         const config = { headers: { Authorization: `Bearer ${token}` } };
//         const response = await axios.get("http://127.0.0.1:8000/subjects/count/", config);
//         setSubjectCount(response.data.total_subject_count); // Set the count from API response
//       } catch (err) {
//         console.error("Error fetching subject count:", err); // Log the error
//       } finally {
//         // Any final cleanup, if needed
//       }
//     };
    

//     fetchSubjectCount();
//   }, [token]); // Include token in dependency array to re-fetch if it changes

//   return (
//            <div className="totalsubject">
//             <p>Total Subjects:{subjectCount}</p>
//           </div>
//   );
// };

// export default SubjectCountView;



// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import CircularProgress from "@mui/material/CircularProgress";
// // import Box from "@mui/material/Box";
// // import Typography from "@mui/material/Typography";
// // import Alert from "@mui/material/Alert";

// // const SubjectCountView = () => {
// //   const [subjectCount, setSubjectCount] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");

// //   useEffect(() => {
// //     const fetchSubjectCount = async () => {
// //       try {
// //         const response = await axios.get("http://127.0.0.1:8000/subjects/count/");
// //         setSubjectCount(response.data.total_subject_count);
// //       } catch (err) {
// //         setError("Error fetching subject count. Please try again later.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchSubjectCount();
// //   }, []);

// //   return (
// //     <Box
// //       sx={{
// //         display: "flex",
// //         flexDirection: "column",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         height: "100vh",
// //       }}
// //     >
// //       {loading ? (
// //         <CircularProgress />
// //       ) : error ? (
// //         <Alert severity="error">{error}</Alert>
// //       ) : (
// //         <Box
// //           sx={{
// //             textAlign: "center",
// //             border: "1px solid #ddd",
// //             borderRadius: "8px",
// //             padding: "20px",
// //             boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
// //             maxWidth: "300px",
// //           }}
// //         >
// //           <Typography variant="h4" gutterBottom>
// //             Total Subjects
// //           </Typography>
// //           <Typography
// //             variant="h2"
// //             sx={{ color: "#1976d2", fontWeight: "bold" }}
// //           >
// //             {subjectCount}
// //           </Typography>
// //         </Box>
// //       )}
// //     </Box>
// //   );
// // };

// // export default SubjectCountView;

